module.exports = __webpack_public_path__ + "static/media/18.bbc97053.JPG";